export enum ColumnVisibilityType {
  Visible,
  CanBeHidden,
  CanBeVisible,
}
